import { Card } from '@ets/design-system';
import CardBody from './Body/Body';
import CardHeader from './Header/Header';
import CardFooter from './Footer/Footer';

export default Object.assign(Card, {
  Header: CardHeader,
  Body: CardBody,
  Footer: CardFooter,
});
